import { render, staticRenderFns } from "./CannedLetter.vue?vue&type=template&id=12f301df"
import script from "./CannedLetter.vue?vue&type=script&lang=js"
export * from "./CannedLetter.vue?vue&type=script&lang=js"
import style0 from "./CannedLetter.vue?vue&type=style&index=0&id=12f301df&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f301df')) {
      api.createRecord('12f301df', component.options)
    } else {
      api.reload('12f301df', component.options)
    }
    module.hot.accept("./CannedLetter.vue?vue&type=template&id=12f301df", function () {
      api.rerender('12f301df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/TemplateMaintain/CannedLetter.vue"
export default component.exports